<template>
  <div class="popover-user-menu">
    <div class="top">
      <div class="image-wrap">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
          <filter id="blur">
              <feGaussianBlur stdDeviation="15" />
          </filter>
        </svg>
        <div class="background-mask">
          <div class="full-picture blur" :style="pictureBackgroundImage"></div>
        </div>
        <div class="image-circle">
          <div class="image" :style="pictureBackgroundImage"></div>
          <i :class="userIconClass"></i>
        </div>
      </div>
      <p class="name">{{ fullName }}</p>
      <p class="email">{{ roleOrEmail }}</p>
    </div>

    <p class="ui-element horizontal-divider welcome">{{ $t('label.welcome_to_diet_creator') }}</p>

    <nuttrema-menu-list theme="popover-nav is-user-menu">
      <template slot="vertical-top">

        <nuttrema-menu-list-item>
          <p class="list-item-label">{{ $t('label.quick_links') }}</p>
        </nuttrema-menu-list-item>
        <section>

          <nuttrema-menu-list-item>
            <a class="list-item-link" :class="{ 'is-active': isActive('professional-home') }" @click="routerLink('professional-home')">
              <span>{{ $t('label.home') }}</span>
            </a>
          </nuttrema-menu-list-item>

          <nuttrema-menu-list-item
            v-if="checkScopesPermitionAndRequiredSubscribedFeature(SCOPES.CREATOR, _get(PersonalProfile, 'meta.permissions.scopes',{}), PERMISSIONS_SUBSCRIBED_PLAN.PROGRAM_DURATION, SubscribedPlan)">
            <a class="list-item-link" :class="{ 'is-active': isActive('diets-list') }" @click="routerLink('diets-list')">
              <span>{{ $t('label.diets') }}</span>
            </a>
          </nuttrema-menu-list-item>

          <nuttrema-menu-list-item
            v-if="checkScopesPermitionAndRequiredSubscribedFeature(SCOPES.INSTANCE_STAFF, _get(PersonalProfile, 'meta.permissions.scopes',{}), PERMISSIONS_SUBSCRIBED_PLAN.PARTICIPANTS, SubscribedPlan)">
            <a class="list-item-link" :class="{ 'is-active': isActive('participants-list') }" @click="routerLink('participants-list')">
              <span>{{ $t('label.my_participants') }}</span>
            </a>
          </nuttrema-menu-list-item>

          <nuttrema-menu-list-item
            v-if="checkScopesPermitionAndRequiredSubscribedFeature(SCOPES.CREATOR, _get(PersonalProfile, 'meta.permissions.scopes',{}), PERMISSIONS_SUBSCRIBED_PLAN.CUSTOM_FOOD_ITEMS, SubscribedPlan)">
            <a class="list-item-link" :class="{ 'is-active': isActive('food-products-list') }" @click="routerLink('food-products-list')">
              <span>{{ $t('label.stuff_to_eat') }}</span>
            </a>
          </nuttrema-menu-list-item>
        </section>

        <nuttrema-menu-list-item>
          <p class="list-item-label">{{ $t('label.settings') }}</p>
        </nuttrema-menu-list-item>

        <section>
          <nuttrema-menu-list-item>
             <a class="list-item-link" :class="{ 'is-active': isActive('my-preferences-personal') }" @click="routerLink('my-preferences-personal')">
               <span>{{ $t('label.my_preferences') }}</span>
             </a>
          </nuttrema-menu-list-item>
        </section>
      </template>

      <nuttrema-menu-list-item slot="vertical-bottom">
        <el-button type="info" class="w-100" @click="logout">{{ $t('label.logout') }}</i></el-button>
      </nuttrema-menu-list-item>
    </nuttrema-menu-list>

  </div>
</template>

<script>
import { get, isEmpty, find } from 'lodash';
import { checkScopesPermitionAndRequiredSubscribedFeature } from 'utils/check-permissions';

import { SCOPES } from 'constants/roles';
import { PERMISSIONS_SUBSCRIBED_PLAN } from 'constants/permissions';

import PageProps from 'components/mixins/page-props';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';

export default {
  name: 'popover-user-menu',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaMenuList,
    NuttremaMenuListItem,
  },
  data() {
    return {
      SCOPES,
      PERMISSIONS_SUBSCRIBED_PLAN,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    SubscribedPlan() {
      return get(this.$store.getters.InstanceSubscribedPlanSummarized, 'data.subscribed_plan');
    },
    fullName() {
      const personalTitle = get(this.PersonalProfile, 'data.personal_title') || '';
      const fullName = get(this.PersonalProfile, 'data.full_name', '');
      const name = `${personalTitle} ${fullName}`;
      return name.trim();
    },
    roleOrEmail() {
      const roles = get(this.PersonalProfile, 'data.Roles', []);
      let primaryRole = null;
      if (!isEmpty(roles)) {
        primaryRole = find(roles, role => role.PersonRole.primary_role);
      }
      const email = get(this.PersonalProfile, 'data.email', '');
      return primaryRole ? primaryRole.name : email;
    },
    userIconClass() {
      const gender = get(this.PersonalProfile, 'data.gender', 'male');
      return gender === 'female' ? 'icon-ca-user-female' : 'icon-ca-user-male';
    },
    pictureBackgroundImage() {
      const path = get(this.PersonalProfile, 'data.ProfilePicture.path', '');
      const picture = get(this.PersonalProfile, 'data.ProfilePicture.thumbnails.large.filename', '');
      return `backgroundImage: url(${process.env.IMAGES_ROOT}${path}${picture})`;
    },
  },
  methods: {
    routerLink(name) {
      this.$emit('close');
      this.$router.push({ name });
    },
    close() {
      this.$emit('close');
    },
    logout() {
      this.$router.push({ name: this.PAGES.PROFESSIONAL.LOGOUT });
    },
    isActive(name) {
      const current = get(this.$router, 'currentRoute.name', false);
      return current && current === name;
    },
    checkScopesPermitionAndRequiredSubscribedFeature,
  },
  created() {
    const id = get(this.PersonalProfile, 'data.id', false);
    if (!id) this.$store.dispatch('GetPersonalProfile');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/theme/colors";
@import "~styles/theme/person-colors";
@import '~styles/mixins/mixins';
@import '~styles/mixins/gradients';

.popover-user-menu {
  display: flex;
  flex-grow: 1;
  align-self: stretch;
  flex-direction: column;
  min-width: 18em;

  &:after {
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    content: '';
    height: 100%;
    opacity: 0.1;
    position: absolute;
    background: transparent url('~assets/images/dc-logo-bg.svg') no-repeat;
    background-position: bottom -4em right -6em;
    background-size: 28em;
  }

  > * {
    z-index: 1;
  }

  .top {
    text-align: center;

    .btn-close {
      z-index: 1;
      color: #fff;
      margin: 0.5em;
      padding: 0.5em;
      top: 0; left: 0;
      text-align: left;
      position: absolute;
      width: calc(100% - 1em);
      border-top-left-radius: 0.25em;
      border-top-right-radius: 0.25em;
      background-color: rgba(0,0,0,0.35);
    }

    .image-wrap {
      padding: 1em 0 0;
      position: relative;

      svg {
        display: none;
      }

      .blur {
        // filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='0');
        // filter: blur(0px);

        transition: 1s;
        top: -5%; left: -5%;
        position: absolute;
        filter: url(#blur);
        filter: blur(15px);
        filter:progid:DXImageTransform.Microsoft.Blur(PixelRadius='15');
      }

      .full-picture {
        width: 110%;
        height: 110%;
        position: absolute;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
      }

      .image-circle {
        z-index: 1;
        width: 10em;
        height: 10em;
        margin-top: 4em;
        overflow: hidden;
        position: relative;
        border-radius: 50%;
        display: inline-block;
        border: 0.5em solid #fff;
        background-color: $professional-leader;
         .image {
          width: 100%;
          height: 100%;
          top: 0; left: 0;
          position: absolute;
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-position: center center;
        }
        i {
          font-size: 7rem;
          line-height: 8.5rem;
          color: #fff;
        }
      }

      .background-mask {
        z-index: 0;
        height: 12em;
        margin: 0.5em;
        top: 0; left: 0;
        overflow: hidden;
        position: absolute;
        width: calc(100% - 1em);
        // background: $turquoise;
        border-top-left-radius: 0.25em;
        border-top-right-radius: 0.25em;
        clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);
        -webkit-clip-path: polygon(0 0, 100% 0, 100% 60%, 0% 100%);

        @include gradient-vertical($professional-leader, $professional-leader-light);
        background-size: 150% auto;
        background-position: center center;
        background-image: url(~assets/images/svg-shapes/shape-01-transparent-black-20.svg);
      }
    }

  }

  .horizontal-divider {
    margin: 1em 0.5em;
  }

  .name {
    font-weight: 800;
    font-size: 1.15em;
  }

  .email {
    color: $gray-light;
  }

  aside {
    margin: 0 1em;
    > * {
      z-index: 1;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/menu/persons/popover-user-menu.vue